<template>
    <BasePanel
        v-if="items.length > 0"
        :headline="panelHeadline"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="300"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            >
                
                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.alvId`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:text>
                            {{ $t('lang_GENERIC_CAPTION_ALVID') }}: {{ item.alvId }}
                        </template>
                        <template v-slot:content>
                            <span :alvqa="alvqa + '-list-row-' + item.id + '-text-alvId'">{{ item.alvId }}</span>
                        </template>
                    </BaseTooltip>
                </template>
                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-contract-name'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.licensor`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:text>
                            {{ item.licensor !== null ? $alvPlugin.showNameOfAzEntry(item.licensor) + ' (' + $t('lang_GENERIC_CAPTION_ALVID') +': ' + item.licensor.alvId + ' | ' + 
                                getIPI(item) + ' | ' + getKTO(item) + ')' : '' }}
                        </template>
                        <template v-slot:content>
                            <span :alvqa="alvqa + '-list-row-' + item.id + '-text-licensor'">{{ $alvPlugin.showNameOfAzEntry(item.licensor) }}</span>
                        </template>
                    </BaseTooltip>
                </template>

            
            </v-data-table>
        </template>
    
    </BasePanel>
  
</template>

<script>

import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name:'LabelContractsGroupedContractsReadOnlyPanel',

    components: {
        BasePanel,
        BaseTooltip,
    },

    data() {
        return {
            alvqa: 'contracts-label-read-only-panel-grouped-contracts'
        }
    },

    methods: {
        getIPI(item){
            let temp = item.licensor.ipi
            if(temp === null){
                temp = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }
            return this.$t('lang_GENERIC_AZ_CAPTION_IPI') + ': '+ temp
        },
        getKTO(item){
            let yKTO = item.licensor.ykto 
            let hKTO = item.licensor.hkto
            let uKTO = item.licensor.ukto
            if(yKTO === null){
                yKTO = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }
            if(hKTO === null){
                hKTO = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') 
            }
            if(uKTO === null){
                uKTO = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') 
            }
            return this.$t('lang_GENERIC_CAPTION_KTO') + ': ' + yKTO + ' - ' + hKTO + ' - ' + uKTO
        },
    },

    computed: {
        items() {
            return this.$store.getters.getLabelContractsGroupedContracts
        },
        groupName() {
            return this.$store.getters.getLabelContractsDetailGroupName
        },
        panelHeadline() {
            let base = this.$t('lang_PUBLISHING_CONTRACTS_GROUPED_CONTRACTS')
            let beta = ' (' + this.$t('lang_GENERIC_CAPTION_BETA_DO_NOT_USE') + ')'
            if(this.groupName) return base + ': ' + this.groupName + beta
            return base + beta
        },
        headers() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'),
                    value: "alvId",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-alvId'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CONTRACT_TITLE'),
                    value: "title",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-contract-name'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY'),
                    value: "licensor",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-licensor'
                },
            ]
        },
    }

}
</script>
